module.exports = __webpack_public_path__ + "img/horizontal_2_1_r_8004.e81e18e5.png";